import React from 'react';
import { a } from 'react-router-dom';
import image from '../../assets/signature.png'
const Header = () => {
    return (
        <div class="navbar bg-[#4db5ff] flex flex-row justify-between">
            <div class="">
                <div class="dropdown">
                    <label tabindex="0" class="btn btn-ghost lg:hidden">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="#FFFFFF"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                    </label>
                    <ul tabindex="0" className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box text-xl">
                        <li><a href='/'>Home</a></li>
                        <li><a href='/#projects'>My Projects</a></li>
                        <li><a href='/#education'>Education</a></li>
                        <li><a href='/#experience'>Experience</a></li>
                        <li><a href='/aboutme'>About Me</a></li>
                        <li><a href='/blogs'>Blogs</a></li>
                    </ul>
                </div>
                <a href='/' className='w-10/12'><img src={image} alt="" /></a>
            </div>
            <div class="  hidden lg:flex ">
                <ul class="menu menu-horizontal p-0 mr-20 text-lg text-white">
                    <li><a href='/'>Home</a></li>
                    <li><a href='/#projects'>My Projects</a></li>
                    <li><a href='/#education'>Education</a></li>
                    <li><a href='/#experience'>Experience</a></li>
                    <li><a href='/aboutme'>About Me</a></li>
                    <li><a href='/blogs'>Blogs</a></li>

                </ul>
            </div>

        </div>
    );
};

export default Header;